module.exports = __webpack_public_path__ + "static/media/data-analyst-feature-1.f8bc9d1e.svg";